var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2127_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 17C42.6836 27 57.0498 33 57.0498 44.4C57.0498 45.9913 56.1595 47.5174 54.5746 48.6426C52.9898 49.7679 50.8404 50.4 48.5991 50.4C46.3578 50.4 44.2084 49.7679 42.6236 48.6426C41.0387 47.5174 40.1484 45.9913 40.1484 44.4C40.1484 44.2939 40.089 44.1922 39.9834 44.1172C39.8777 44.0421 39.7344 44 39.585 44C39.4356 44 39.2923 44.0421 39.1866 44.1172C39.081 44.1922 39.0216 44.2939 39.0216 44.4C39.0216 52.4 41.8385 53 44.3737 57H29.7259C32.2611 53 35.078 52.4 35.078 44.4C35.078 44.2939 35.0186 44.1922 34.913 44.1172C34.8073 44.0421 34.664 44 34.5146 44C34.3652 44 34.2219 44.0421 34.1162 44.1172C34.0106 44.1922 33.9512 44.2939 33.9512 44.4C33.9512 45.9913 33.0609 47.5174 31.4761 48.6426C29.8912 49.7679 27.7418 50.4 25.5005 50.4C23.2592 50.4 21.1098 49.7679 19.525 48.6426C17.9401 47.5174 17.0498 45.9913 17.0498 44.4C17.0498 33 31.416 27 37.0498 17Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2127_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 168V187.826C124 191.055 122.736 194.151 120.485 196.434C118.235 198.717 115.183 200 112 200C108.817 200 105.765 198.717 103.515 196.434C101.264 194.151 100 191.055 100 187.826V148.174C100 144.945 101.264 141.849 103.515 139.566C105.765 137.283 108.817 136 112 136C115.183 136 118.235 137.283 120.485 139.566C122.736 141.849 124 144.945 124 148.174V168Z",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2127_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.95 319C181.316 309 166.95 303 166.95 291.6C166.95 290.009 167.841 288.483 169.425 287.357C171.01 286.232 173.16 285.6 175.401 285.6C177.642 285.6 179.792 286.232 181.376 287.357C182.961 288.483 183.852 290.009 183.852 291.6C183.852 291.706 183.911 291.808 184.017 291.883C184.122 291.958 184.266 292 184.415 292C184.564 292 184.708 291.958 184.813 291.883C184.919 291.808 184.978 291.706 184.978 291.6C184.978 283.6 182.161 283 179.626 279H194.274C191.739 283 188.922 283.6 188.922 291.6C188.922 291.706 188.981 291.808 189.087 291.883C189.193 291.958 189.336 292 189.485 292C189.635 292 189.778 291.958 189.884 291.883C189.989 291.808 190.049 291.706 190.049 291.6C190.049 290.009 190.939 288.483 192.524 287.357C194.109 286.232 196.258 285.6 198.499 285.6C200.741 285.6 202.89 286.232 204.475 287.357C206.06 288.483 206.95 290.009 206.95 291.6C206.95 303 192.584 309 186.95 319Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2127_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2127_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 -1 129 205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2127_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 207 319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0S);
export default __webpack_public_path__ + "static/media/0S.7a0d4c59d9d1d15db2ce50427e68d4a8.svg";
export { ForwardRef as ReactComponent };